import { t } from 'i18n';

import { SasModal } from '../../SasModal';

import { buttonContainer, buttonOverride } from './styles';

type Props = {
  onClose: () => void;
  onRemove: () => void;
};

export const WarningModal = ({ onClose, onRemove }: Props) => {
  const onSave = () => {
    onRemove();
    onClose();
  };
  return (
    <SasModal open={true} handleClose={onClose}>
      <div>
        <h3>{t('remove.ffp.text')}</h3>
        <p>{t('remove.ffp.title')}</p>
      </div>

      <div css={buttonContainer}>
        <button css={buttonOverride} onClick={onClose}>
          {t('common:cancel')}
        </button>
        <button onClick={onSave}>{t('common:yes')}</button>
      </div>
    </SasModal>
  );
};
